const DEFAULT_SALES_CALENDAR_URL =
  'https://cal.com/team/sales-teramot/intro-teramot?overlayCalendar=true';

export const SALES_CALENDAR_URL: string =
  import.meta.env.VITE_SCHEDULE_URL || DEFAULT_SALES_CALENDAR_URL;
